export default function AuthorBio() {
  return (
    <section id="about" className="py-16 md:py-32 bg-amber-950">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-12 items-center">
          <div className="lg:col-span-2 max-w-xs mx-auto w-full lg:max-w-none">
            <div className="overflow-hidden border-2 border-amber-500 p-1 bg-amber-950">
              <img
                src="https://static.readdy.ai/image/b0bf0689308dc3dbfe962826cee4efbe/6d2ceda2edb36098947cfc1fcde7ae02.png"
                alt="John Reed - Author"
                className="w-full h-auto object-contain transition-all duration-500"
              />
            </div>
          </div>

          <div className="lg:col-span-3 lg:pl-12">
            <div className="inline-block px-3 py-1.5 border border-amber-600/60 text-xs uppercase tracking-widest text-amber-400 mb-4 md:mb-6">
              ABOUT THE AUTHOR
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-2 leading-tight uppercase">
              <span className="text-amber-50">John</span>
              <br />
              <span className="text-amber-400">Reed</span>
            </h2>

            <div className="w-12 h-1 bg-amber-500 mt-3 mb-6 md:mt-4 md:mb-8"></div>

            <div className="max-w-2xl">
              <p className="text-sm md:text-base text-amber-100/75 leading-relaxed mb-4 md:mb-6">
                John Reed knows what it means to walk out of prison with nothing but a paper bag and a second chance. His journey from incarceration to author, speaker, and advocate is the foundation of everything written in this book.
              </p>
              <p className="text-sm md:text-base text-amber-100/75 leading-relaxed mb-4 md:mb-6">
                The Forgotten Felon Blueprint is not theory — it is the raw, unfiltered survival guide John wishes he had on day one. Built from personal pain, setbacks, and hard-won breakthroughs, every page reflects the real challenges faced by returning citizens navigating a world that wasn't built for them.
              </p>
              <p className="text-sm md:text-base text-amber-100/75 leading-relaxed mb-4 md:mb-6">
                Today, John speaks at reentry programs, correctional facilities, and community events across the country, helping formerly incarcerated men and women rebuild their minds, their habits, their circles, and their entire lives.
              </p>
              <p className="text-sm md:text-base text-amber-400 font-bold uppercase tracking-widest">
                — Author · Speaker · Reentry Advocate
              </p>
            </div>

            <div className="flex items-center space-x-3 md:space-x-4 mt-8 md:mt-10">
              {['ri-twitter-x-line', 'ri-instagram-line', 'ri-facebook-fill', 'ri-linkedin-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center border border-amber-800/60 text-amber-300/60 hover:bg-amber-600 hover:text-amber-50 hover:border-amber-600 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
                >
                  <i className={`${icon} text-base md:text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
